import styled from 'styled-components';
import { Container } from 'react-grid-system';

import { CenterDiv } from './CenterDiv';
import { ErrorMessage } from './ErrorMessage';
import { FlexContainer } from './FlexContainer';

export const LoginContainer = styled(Container)`
  padding: 0 !important;
  overflow: hidden;
`;

export const LoginForm = styled(CenterDiv)`
  background-color: ${(props) => props.theme.colors.loginBackgroundColor};
  height: 100vh;
  text-align: center;
  align-content: center;
`;

export const LoginFormContent = styled(FlexContainer)`
  color: ${(props) => props.theme.colors.white};
  justify-content: center;
  position: relative;
`;

export const LoginError = styled(ErrorMessage)`
  position: absolute;
  top: 135px;
  font-size: 12px;
  left: 145px;
  @media (max-width: 992px) {
    left: 50px;
  }
`;

export const InputForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  position: relative;
`;

export const ForgotPassword = styled.p`
  position: absolute;
  font-size: 13px;
  cursor: pointer;
  top: 50px;
  right: -10px;
  color: ${(props) => props.theme.colors.purple};
`;
